import React from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css'; // Import default styles
import '../css/myCalendar.css'; // Import custom styles

const localizer = momentLocalizer(moment);

function Mycalendar() {
  // Example events data with all-day events
  const events = [
    {
      title: 'New Session Begins',
      start: new Date(2024, 3, 3), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 3),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Eid-UI-Fitr',
      start: new Date(2024, 3,11), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 11),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Kanni Tharyamal Trophy, Cricket Tournament',
      start: new Date(2024, 3,12), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 12),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Cricket Tournament',
      start: new Date(2024, 3,12), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 12),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Second Saturday',
      start: new Date(2024, 3,13), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 13),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Dr. B.R. Ambedkar Jayanti',
      start: new Date(2024, 3,14), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 14),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Career Fair',
      start: new Date(2024, 3,15), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 15),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'World Art Day (Activity Classes I to VIII)',
      start: new Date(2024, 3,15), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 15),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Pre-Primary Welcome Party &  Favorite Color Day',
      start: new Date(2024, 3,16), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 16),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Ram Navami',
      start: new Date(2024, 3,17), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 17),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'World Heritage Day PPT on any monument (Class VI -VIII)',
      start: new Date(2024, 3,18), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 18),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: '(Awareness to keep our monuments clean) ATULAYA BHARAT (Inter Class Heritage Quize) (Classes IX & XII)',
      start: new Date(2024, 3,18), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 18),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'PYP Parent Orientation & Open House (class Pre-Primary to V)',
      start: new Date(2024, 3,20), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 20),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: 'Observance of Light off Hour',
      start: new Date(2024, 3,20), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 20),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: 'Mahaveer Jayanti',
      start: new Date(2024, 3,21), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 21),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'World Creativity & Innovation Day',
      start: new Date(2024, 3,21), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 21),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Internaltional Mother Earth Day',
      start: new Date(2024, 3,22), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 22),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'English Language Day Inter House Ad Mad Show Competition (Classes IX To XII)',
      start: new Date(2024, 3,23), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 23),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Inter House Handwriting Competiton (Class I to V)',
      start: new Date(2024, 3,24), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 24),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'Inter Class Hindi Storytelling Competition (Class VI to VII)',
      start: new Date(2024, 3,24), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 24),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'CBP for Educators',
      start: new Date(2024, 3, 24), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 24),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: 'Swaad Bharat Ka (Class VI)',
      start: new Date(2024, 3, 26), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 26),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Mosaic-Art-Fest',
      start: new Date(2024, 3, 27), // December 1, 2024 (all-day)
      end: new Date(2024, 3, 27),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'International Labor Day',
      start: new Date(2024, 4,1), // December 1, 2024 (all-day)
      end: new Date(2024, 4,1),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Pre-Primary Pink Color Day',
      start: new Date(2024, 4,7), // December 1, 2024 (all-day)
      end: new Date(2024, 4,7),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Inter House Poem Recition Competition (Class I to V)',
      start: new Date(2024, 4,8), // December 1, 2024 (all-day)
      end: new Date(2024, 4,8),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'Inter House Literay Culinarian Contest (Classes IX to XII)',
      start: new Date(2024, 4,8), // December 1, 2024 (all-day)
      end: new Date(2024, 4,8),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Sanskar Talks',
      start: new Date(2024,4,10), // December 1, 2024 (all-day)
      end: new Date(2024, 4,10),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'World Technology Day',
      start: new Date(2024,4,11), // December 1, 2024 (all-day)
      end: new Date(2024, 4,11),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Intra Class Current Affairs Competition (Class VI to VIII)',
      start: new Date(2024,4,11), // December 1, 2024 (all-day)
      end: new Date(2024, 4,11),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'CBP for Educators',
      start: new Date(2024,4,11), // December 1, 2024 (all-day)
      end: new Date(2024, 4,11),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: "Mother's day",
      start: new Date(2024,4,12), // December 1, 2024 (all-day)
      end: new Date(2024, 4,12),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Summer Vacation Begins for (Class Pre - Primary to XII',
      start: new Date(2024,4,15), // December 1, 2024 (all-day)
      end: new Date(2024, 6,1),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'WinterBreak',
    },
    {
      title: 'Buddh Purnima',
      start: new Date(2024,4,23), // December 1, 2024 (all-day)
      end: new Date(2024, 4,23),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'World No Tabacco Day',
      start: new Date(2024,4,31), // December 1, 2024 (all-day)
      end: new Date(2024, 4,31),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'World Environment Day',
      start: new Date(2024,5,5), // December 1, 2024 (all-day)
      end: new Date(2024, 5,5),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Maharana Pratap Jayanti',
      start: new Date(2024,5,9), // December 1, 2024 (all-day)
      end: new Date(2024, 5,9),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title:"Father's Day",
      start: new Date(2024,5,16), // December 1, 2024 (all-day)
      end: new Date(2024, 5,16),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title:'Id-UI-Zuha',
      start: new Date(2024,5,17), // December 1, 2024 (all-day)
      end: new Date(2024, 5,17),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'National Reading Day',
      start: new Date(2024,5,19), // December 1, 2024 (all-day)
      end: new Date(2024, 5,19),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'International Yoga Day',
      start: new Date(2024,5,21), // December 1, 2024 (all-day)
      end: new Date(2024, 5,21),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'School Reopens',
      start: new Date(2024,6,1), // December 1, 2024 (all-day)
      end: new Date(2024,6,1),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Desi Chatkara (Class VII)',
      start: new Date(2024,6,3), // December 1, 2024 (all-day)
      end: new Date(2024,6,3),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Pre-Primary Orange Color Day',
      start: new Date(2024,6,9), // December 1, 2024 (all-day)
      end: new Date(2024,6,9),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Inter House Best out of Waste Competition (Class I to V)',
      start: new Date(2024,6,10), // December 1, 2024 (all-day)
      end: new Date(2024,6,10),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      // category: 'SpecialDay',
      category: 'InterHouse1to5',
    },
    {
      title: 'Science & Mathematics Exhibition (Class VI to XII)',
      start: new Date(2024,6,10), // December 1, 2024 (all-day)
      end: new Date(2024,6,10),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      // category: 'InterHouse1to5',
      category: 'SpecialDay',
    },
    {
      title: 'National Paper Bag Day',
      start: new Date(2024,6,12), // December 1, 2024 (all-day)
      end: new Date(2024,6,12),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      // category: 'InterHouse1to5',
      category: 'SpecialDay',
    },
    {
      title: 'Youth Skill Day',
      start: new Date(2024,6,15), // December 1, 2024 (all-day)
      end: new Date(2024,6,15),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      // category: 'InterHouse1to5',
      category: 'SpecialDay',
    },
    {
      title: 'Moharram',
      start: new Date(2024,6,17), // December 1, 2024 (all-day)
      end: new Date(2024,6,17),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      // category: 'InterHouse1to5',
      category: 'Holiday',
    },
    {
      title: 'Investiture Ceremony',
      start: new Date(2024,6,20), // December 1, 2024 (all-day)
      end: new Date(2024,6,20),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      // category: 'InterHouse1to5',
      category: 'Holiday',
    },
    {
      title: 'Observance of Ligth off Hour',
      start: new Date(2024,6,20), // December 1, 2024 (all-day)
      end: new Date(2024,6,20),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: 'Guru Purnima',
      start: new Date(2024,6,21), // December 1, 2024 (all-day)
      end: new Date(2024,6,21),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Deeply Seeded (Classes VI to XII)',
      start: new Date(2024,6,24), // December 1, 2024 (all-day)
      end: new Date(2024,6,24),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Pre-Primary Meditation Day',
      start: new Date(2024,6,26), // December 1, 2024 (all-day)
      end: new Date(2024,6,26),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Taste Fest International (Class VII)',
      start: new Date(2024,6,26), // December 1, 2024 (all-day)
      end: new Date(2024,6,26),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Open House (Classes VI to XII)',
      start: new Date(2024,6,27), // December 1, 2024 (all-day)
      end: new Date(2024,6,27),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: 'CBP for Educators',
      start: new Date(2024,6,31), // December 1, 2024 (all-day)
      end: new Date(2024,6,31),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: 'Pre-Primary Green Color Day',
      start: new Date(2024,7,6), // December 1, 2024 (all-day)
      end: new Date(2024,7,6),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Design yor Own DIY Robot (Classes VI to VIII)',
      start: new Date(2024,7,7), // December 1, 2024 (all-day)
      end: new Date(2024,7,7),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Code it !!Scratch it!! (Classes I to VIII)',
      start: new Date(2024,7,7), // December 1, 2024 (all-day)
      end: new Date(2024,7,7),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "The International Day of the world's indigenous people's",
      start: new Date(2024,7,9), // December 1, 2024 (all-day)
      end: new Date(2024,7,9),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Opne House (Classes Pre-Primary to V)",
      start: new Date(2024,7,10), // December 1, 2024 (all-day)
      end: new Date(2024,7,10),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: 'Inter House Patriotic Song Competition (Classes I to VII)',
      start: new Date(2024,7,14), // December 1, 2024 (all-day)
      end: new Date(2024,7,14),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Independence Day Celebration',
      start: new Date(2024,7,15), // December 1, 2024 (all-day)
      end: new Date(2024,7,15),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Sankar Model United Nations',
      start: new Date(2024,7,16), // December 1, 2024 (all-day)
      end: new Date(2024,7,16),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Sankar Model United Nations',
      start: new Date(2024,7,17), // December 1, 2024 (all-day)
      end: new Date(2024,7,17),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Observance of Light off Hour',
      start: new Date(2024,7,17), // December 1, 2024 (all-day)
      end: new Date(2024,7,17),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: 'Raksha Bandhan',
      start: new Date(2024,7,19), // December 1, 2024 (all-day)
      end: new Date(2024,7,19),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'World Photography Day',
      start: new Date(2024,7,19), // December 1, 2024 (all-day)
      end: new Date(2024,7,19),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Short-film Making Activity (classes VI to XII)',
      start: new Date(2024,7,21), // December 1, 2024 (all-day)
      end: new Date(2024,7,21),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Pre-primary Gardening Day',
      start: new Date(2024,7,23), // December 1, 2024 (all-day)
      end: new Date(2024,7,23),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Janamashtami',
      start: new Date(2024,7,26), // December 1, 2024 (all-day)
      end: new Date(2024,7,26),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'CBP for Educators',
      start: new Date(2024,7,28), // December 1, 2024 (all-day)
      end: new Date(2024,7,28),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: 'National Sports Day',
      start: new Date(2024,7,29), // December 1, 2024 (all-day)
      end: new Date(2024,7,29),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Teacher's Day",
      start: new Date(2024,8,5), // December 1, 2024 (all-day)
      end: new Date(2024,8,5),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: "International Day of Charity",
      start: new Date(2024,8,5), // December 1, 2024 (all-day)
      end: new Date(2024,8,5),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Ganesh Chaturthi',
      start: new Date(2024,8,7), // December 1, 2024 (all-day)
      end: new Date(2024,8,7),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: "Grandparent's Day",
      start: new Date(2024,8,8), // December 1, 2024 (all-day)
      end: new Date(2024,8,8),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: '9/11 Remembrance Day',
      start: new Date(2024,8,9), // December 1, 2024 (all-day)
      end: new Date(2024,8,9),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Pre-Primary Blue Color Day',
      start: new Date(2024,8,10), // December 1, 2024 (all-day)
      end: new Date(2024,8,10),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Inter House Hindi Debate Competition (Classes I to V)',
      start: new Date(2024,8,11), // December 1, 2024 (all-day)
      end: new Date(2024,8,11),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'Ramdev Jayanti',
      start: new Date(2024,8,13), // December 1, 2024 (all-day)
      end: new Date(2024,8,13),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'First Aid Kit Making Activity (Classes I to V)',
      start: new Date(2024,8,13), // December 1, 2024 (all-day)
      end: new Date(2024,8,13),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'Hindi Diwas Day',
      start: new Date(2024,8,14), // December 1, 2024 (all-day)
      end: new Date(2024,8,14),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Barawafat',
      start: new Date(2024,8,16), // December 1, 2024 (all-day)
      end: new Date(2024,8,16),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Pre-Primary Elocution',
      start: new Date(2024,8,20), // December 1, 2024 (all-day)
      end: new Date(2024,8,20),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'International Day of Peace',
      start: new Date(2024,8,21), // December 1, 2024 (all-day)
      end: new Date(2024,8,21),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Observance of Light off Hour',
      start: new Date(2024,8,21), // December 1, 2024 (all-day)
      end: new Date(2024,8,21),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: 'CBP for Educators',
      start: new Date(2024,8,25), // December 1, 2024 (all-day)
      end: new Date(2024,8,25),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: 'World Tourism Day',
      start: new Date(2024,8,27), // December 1, 2024 (all-day)
      end: new Date(2024,8,27),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'World Vegetarian Day',
      start: new Date(2024,9,1), // December 1, 2024 (all-day)
      end: new Date(2024,9,1),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Gandhi Jayanti',
      start: new Date(2024,9,2), // December 1, 2024 (all-day)
      end: new Date(2024,9,2),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Navratra Sthapna',
      start: new Date(2024,9,3), // December 1, 2024 (all-day)
      end: new Date(2024,9,3),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Open House for Result Declaration (classes Pre-Primary to XII)',
      start: new Date(2024,9,5), // December 1, 2024 (all-day)
      end: new Date(2024,9,5),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: 'Indian Air Force Day',
      start: new Date(2024,9,8), // December 1, 2024 (all-day)
      end: new Date(2024,9,8),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Pre-Primary White Color Day',
      start: new Date(2024,9,8), // December 1, 2024 (all-day)
      end: new Date(2024,9,8),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'World Mental Health Day',
      start: new Date(2024,9,10), // December 1, 2024 (all-day)
      end: new Date(2024,9,10),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Durga Ashtami',
      start: new Date(2024,9,11), // December 1, 2024 (all-day)
      end: new Date(2024,9,11),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Dussahra',
      start: new Date(2024,9,12), // December 1, 2024 (all-day)
      end: new Date(2024,9,12),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'World Food Day',
      start: new Date(2024,9,16), // December 1, 2024 (all-day)
      end: new Date(2024,9,16),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Inter House Fire Less Cooking Competition (Class I to V)',
      start: new Date(2024,9,16), // December 1, 2024 (all-day)
      end: new Date(2024,9,16),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'Observance of Light off Hour',
      start: new Date(2024,9,19), // December 1, 2024 (all-day)
      end: new Date(2024,9,19),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: 'CBP For Educators',
      start: new Date(2024,9,23), // December 1, 2024 (all-day)
      end: new Date(2024,9,23),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: 'United Nations Day',
      start: new Date(2024,9,24), // December 1, 2024 (all-day)
      end: new Date(2024,9,24),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Pre-Primary Card Making',
      start: new Date(2024,9,25), // December 1, 2024 (all-day)
      end: new Date(2024,9,25),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'No Bag Day Cultural Fest (Class VI to XII)',
      start: new Date(2024,9,26), // December 1, 2024 (all-day)
      end: new Date(2024,9,26),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Diwali Break',
      start: new Date(2024,9,28), // December 1, 2024 (all-day)
      end: new Date(2024,10,3),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'WinterBreak',
    },
    {
      title: 'Diwali',
      start: new Date(2024,9,31), // December 1, 2024 (all-day)
      end: new Date(2024,9,31),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Bhai Dooj',
      start: new Date(2024,10,3), // December 1, 2024 (all-day)
      end: new Date(2024,10,3),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Pre-Primary Brown Color Day',
      start: new Date(2024,10,5), // December 1, 2024 (all-day)
      end: new Date(2024,10,5),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Inter House English Elocution Competition (Class I to V)',
      start: new Date(2024,10,6), // December 1, 2024 (all-day)
      end: new Date(2024,10,6),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'Wold Kindess Day',
      start: new Date(2024,10,13), // December 1, 2024 (all-day)
      end: new Date(2024,10,13),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Childer's Dya",
      start: new Date(2024,10,14), // December 1, 2024 (all-day)
      end: new Date(2024,10,14),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Guru Nanak Jayanti',
      start: new Date(2024,10,15), // December 1, 2024 (all-day)
      end: new Date(2024,10,15),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Observance of Light off Hour',
      start: new Date(2024,10,16), // December 1, 2024 (all-day)
      end: new Date(2024,10,16),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: "Let's Grow Microgreens (Classes I to V)",
      start: new Date(2024,10,20), // December 1, 2024 (all-day)
      end: new Date(2024,10,20),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'Pre-Primary Origami Day',
      start: new Date(2024,10,22), // December 1, 2024 (all-day)
      end: new Date(2024,10,22),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Orientation Session (Class X)',
      start: new Date(2024,10,23), // December 1, 2024 (all-day)
      end: new Date(2024,10,23),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Constitution Day',
      start: new Date(2024,10,26), // December 1, 2024 (all-day)
      end: new Date(2024,10,26),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'CBP For Educators',
      start: new Date(2024,10,27), // December 1, 2024 (all-day)
      end: new Date(2024,10,27),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: 'Sports Day',
      start: new Date(2024, 11, 1), // December 1, 2024 (all-day)
      end: new Date(2024, 11, 1),   // December 1, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'National Pollution Control Day',
      start: new Date(2024, 11, 2), // December 2, 2024 (all-day)
      end: new Date(2024, 11, 2),   // December 2, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Indian Navy Day',
      start: new Date(2024, 11, 4), // December 4, 2024 (all-day)
      end: new Date(2024, 11, 4),   // December 4, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Pre-Primary Little Picasso Day',
      start: new Date(2024, 11, 6), // December 6, 2024 (all-day)
      end: new Date(2024, 11, 6),   // December 6, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Adolescent Peer Leadership Session',
      start: new Date(2024, 11, 7 ), // December 6, 2024 (all-day)
      end: new Date(2024, 11, 7),   // December 6, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Human Rights Day',
      start: new Date(2024, 11, 10 ), // December 6, 2024 (all-day)
      end: new Date(2024, 11, 10),   // December 6, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'DIY Handicraft Exhibition (Classes VI to XII)',
      start: new Date(2024, 11, 11 ), // December 6, 2024 (all-day)
      end: new Date(2024, 11, 11),   // December 6, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Inter House Spell Buster Competition (Class I to V)',
      start: new Date(2024, 11, 18 ), // December 6, 2024 (all-day)
      end: new Date(2024, 11, 18),   // December 6, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'CBP For Educators',
      start: new Date(2024, 11, 18 ), // December 6, 2024 (all-day)
      end: new Date(2024, 11, 18),   // December 6, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: 'Observance of Light off Hour',
      start: new Date(2024, 11, 21 ), // December 6, 2024 (all-day)
      end: new Date(2024, 11, 21),   // December 6, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: 'National Mathematics Day',
      start: new Date(2024, 11, 22 ), // December 6, 2024 (all-day)
      end: new Date(2024, 11, 22),   // December 6, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',

    },
    {
      title: 'Sanskar Fiesta',
      start: new Date(2024, 11, 22 ), // December 6, 2024 (all-day)
      end: new Date(2024, 11, 22),   // December 6, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Christmas Celebration',
      start: new Date(2024, 11, 24 ), // December 24, 2024 (all-day)
      end: new Date(2024, 11, 24),   // December 24, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Pre-Primary Red Color Day',
      start: new Date(2024, 11, 24 ), // December 24, 2024 (all-day)
      end: new Date(2024, 11, 24),   // December 24, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Christmas',
      start: new Date(2024, 11, 25 ), // December 25, 2024 (all-day)
      end: new Date(2024, 11, 25),   // December 25, 2024 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',

    },
    {
      title: 'Winter Break',
      start: new Date(2025, 0, 1 ), // January 1, 2025 (all-day)
      end: new Date(2025, 0, 8),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'WinterBreak',
    },
    {
      title: 'Guru Govind Singh Jayanti',
      start: new Date(2025, 0, 6 ), // January 1, 2025 (all-day)
      end: new Date(2025, 0, 6),   // January 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Lohri',
      start: new Date(2025, 0, 13 ), // January 1, 2025 (all-day)
      end: new Date(2025, 0, 13),   // January 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Pre-Primary Lohri Celebration',
      start: new Date(2025, 0, 13 ), // January 1, 2025 (all-day)
      end: new Date(2025, 0, 13),   // January 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Makar Sankranti',
      start: new Date(2025, 0, 14 ), // January 1, 2025 (all-day)
      end: new Date(2025, 0, 14),   // January 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Indian Army Day',
      start: new Date(2025, 0, 15 ), // January 1, 2025 (all-day)
      end: new Date(2025, 0, 15),   // January 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Observance of Light off Hour',
      start: new Date(2025, 0, 18 ), // January 1, 2025 (all-day)
      end: new Date(2025, 0, 18),   // January 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: 'Awareness Signage on Road Sefety (Class VI to XII)',
      start: new Date(2025, 0, 22 ), // January 1, 2025 (all-day)
      end: new Date(2025, 0, 22),   // January 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Pre-Primary Color Day',
      start: new Date(2025, 0, 24 ), // January 1, 2025 (all-day)
      end: new Date(2025, 0, 24),   // January 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Republic Day Celebration',
      start: new Date(2025, 0, 26 ), // January 1, 2025 (all-day)
      end: new Date(2025, 0, 26),   // January 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'CBP For Educators',
      start: new Date(2025, 0, 29 ), // January 1, 2025 (all-day)
      end: new Date(2025, 0, 29),   // January 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: "Martyr's Day",
      start: new Date(2025, 0, 30 ), // January 1, 2025 (all-day)
      end: new Date(2025, 0, 30),   // January 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Graduation Ceremony",
      start: new Date(2025, 1, 1 ), // January 1, 2025 (all-day)
      end: new Date(2025, 1, 1),   // January 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: "Basant Panchami",
      start: new Date(2025, 1, 2 ), // February 1, 2025 (all-day)
      end: new Date(2025, 1, 2),   // February 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: "Pre-Primary Yellow Color Day",
      start: new Date(2025, 1, 4), // February 1, 2025 (all-day)
      end: new Date(2025, 1, 4),   // February 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: "International Day of Women & Girls in Science",
      start: new Date(2025, 1, 5), // February 1, 2025 (all-day)
      end: new Date(2025, 1, 5),   // February 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Observance of Light off Hour",
      start: new Date(2025, 1, 15), // February 1, 2025 (all-day)
      end: new Date(2025, 1, 15),   // February 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: "CBP for Educators",
      start: new Date(2025, 1, 19), // February 1, 2025 (all-day)
      end: new Date(2025, 1, 19),   // February 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: "Pre-Primary Picnic Day",
      start: new Date(2025, 1, 21), // February 1, 2025 (all-day)
      end: new Date(2025, 1, 21),   // February 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: "International Mother language Day",
      start: new Date(2025, 1, 21), // January 1, 2025 (all-day)
      end: new Date(2025, 1, 21),   // January 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Mahashivratri",
      start: new Date(2025, 1, 26), // January 1, 2025 (all-day)
      end: new Date(2025, 1, 26),   // January 1, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    
    {
      title: "National Science Day (Science Fun with Facts Quiz)",
      start: new Date(2025, 1, 28), // February 26, Mahashivrartri 2025 (all-day)
      end: new Date(2025, 1, 28),   // February 26, Mahashivrartri 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
     
    },
    {
      title: "World Wildlife Day",
      start: new Date(2025, 2, 3), // March 3, 2025 (all-day)
      end: new Date(2025, 2, 3),   // March 3, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "International Women's Day",
      start: new Date(2025, 2, 8), // March 8, 2025 (all-day)
      end: new Date(2025, 2, 8),   // March 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Holi ",
      start: new Date(2025, 2, 14), // March 14, 2025 (all-day)
      end: new Date(2025, 2, 14),   // March 14, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
 
    {
      title: "World Consumer Rights Day",
      start: new Date(2025, 2, 15), // March 15, 2025 (all-day)
      end: new Date(2025, 2, 15),   // March 15, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Observance of Light off Hours",
      start: new Date(2025, 2, 15), // March 15, 2025 (all-day)
      end: new Date(2025, 2, 15),   // March 15, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: "International Day of Happiness",
      start: new Date(2025, 2, 20), // March 20, 2025 (all-day)
      end: new Date(2025, 2, 20),   // March 20, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "World Poetry Day",
      start: new Date(2025, 2, 21), // March 21, 2025 (all-day)
      end: new Date(2025, 2, 21),   // March 21, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "World Water Day",
      start: new Date(2025, 2, 22), // March 21, 2025 (all-day)
      end: new Date(2025, 2, 22),   // March 21, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Open House for Result Declaration (Classes Pre-Primary, I & II)",
      start: new Date(2025, 2, 26), // March 26, 2025 (all-day)
      end: new Date(2025, 2, 26),   // March 26, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
       category: 'CBP4Edu'
    },
    {
      title: "Open House for Result Declartion (Classes III to V)",
      start: new Date(2025, 2, 27), // March 28, 2025 (all-day)
      end: new Date(2025, 2, 26),   // March 28, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
       category: 'CBP4Edu'
    },
    {
      title: "Open House for Result Declaration (Classes VI to IX & XI) ",
      start: new Date(2025, 2, 28), // March 28, 2025 (all-day)
      end: new Date(2025, 2, 26),   // March 28, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
       category: 'CBP4Edu'
    },

    {
      title: 'collaborative Meetings and Professional Development Sessions',
      start: new Date(2025, 3, 1 ), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 6),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'collmet',

    },
   
   
    {
      title: 'Ram Navami',
      start: new Date(2025, 3, 6 ), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 6),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'New Session Begins Wrold Health Day',
      start: new Date(2025, 3, 7 ), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 7),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Global University Fair',
      start: new Date(2025, 3, 9), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 9),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Mahaveer Jayanti',
      start: new Date(2025, 3, 10), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 10),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'PYP Parent Orientation & Open House (Grades Pre-Primary to V)',
      start: new Date(2025, 3, 12), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 12),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Dr. B.R. Ambedkar Jayanti',
      start: new Date(2025, 3, 14), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 14),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Pre-Primary Welcome Party',
      start: new Date(2025, 3, 15), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 15),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Kanni Tharyamal Cricket Tournament',
      start: new Date(2025, 3, 15), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 15),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'World Art Day',
      start: new Date(2025, 3, 16), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 16),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: '1st Round of Inter House (Grades VI to VIII)',
      start: new Date(2025, 3, 16), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 16),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Heritage Quiz (IX-XII)',
      start: new Date(2025, 3, 16), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 16),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'DIY Art: Explore & Create (Grades I to V)',
      start: new Date(2025, 3, 16), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 16),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Art',
    },
    {
      title: 'Good Friday',
      start: new Date(2025, 3, 18), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 18),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'World Heritage Day',
      start: new Date(2025, 3, 18), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 18),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'ATL Activities Hubs of Learning',
      start: new Date(2025, 3, 19), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 19),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Observance of Light off Hour',
      start: new Date(2025, 3, 19), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 19),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: 'ATL Community Day',
      start: new Date(2025, 3, 20), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 20),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'World Creativity & Innovation Day',
      start: new Date(2025, 3, 21), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 21),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'International Mother Earth Day',
      start: new Date(2025, 3, 22), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 21),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Special Assembly: Conservation Skit',
      start: new Date(2025, 3, 22), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 21),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'English Language Day',
      start: new Date(2025, 3, 23), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 23),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Inter House Handwriting Competition (Grades I to V)',
      start: new Date(2025, 3, 23), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 23),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'Inter House Creative Writing Competition (VI to VIII)',
      start: new Date(2025, 3, 23), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 23),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'Inter House Heritage Quiz (IX to XII)',
      start: new Date(2025, 3, 23), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 23),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'University Fair (US)',
      start: new Date(2025, 3, 24), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 24),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Well-Bing Workshop (Grades I to V)',
      start: new Date(2025, 3, 25), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 25),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: 'Mosaic-Art Fest',
      start: new Date(2025, 3, 26), // January 1, 2025 (all-day)
      end: new Date(2025, 3, 26),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'International Labour Day',
      start: new Date(2025, 4, 1), // January 1, 2025 (all-day)
      end: new Date(2025, 4, 1),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Special Assembly',
      start: new Date(2025, 4, 1), // January 1, 2025 (all-day)
      end: new Date(2025, 4, 1),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Gratitude Immersion (Grades I to V)',
      start: new Date(2025, 4, 1), // January 1, 2025 (all-day)
      end: new Date(2025, 4, 1),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Art',
    },
    {
      title: 'Observance of Light off Hour',
      start: new Date(2025, 4, 3), // January 1, 2025 (all-day)
      end: new Date(2025, 4, 3),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: 'Pre-Primary Pink Colour Day',
      start: new Date(2025, 4, 6), // January 1, 2025 (all-day)
      end: new Date(2025, 4, 6),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Paper Bag Making',
      start: new Date(2025, 4, 6), // January 1, 2025 (all-day)
      end: new Date(2025, 4, 6),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Inter House Traditional Food Fest (Swad Bharat ka VI-VIII)',
      start: new Date(2025, 4, 7), // January 1, 2025 (all-day)
      end: new Date(2025, 4, 7),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'Inter House Recitation Competition (Grades I to V)',
      start: new Date(2025, 4, 7), // January 1, 2025 (all-day)
      end: new Date(2025, 4, 7),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: "Mother's Day",
      start: new Date(2025, 4, 9), // January 1, 2025 (all-day)
      end: new Date(2025, 4, 9),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Glow and Grow Summer Party (Grades I to III)',
      start: new Date(2025, 4, 16), // January 1, 2025 (all-day)
      end: new Date(2025, 4, 16),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Art',
    },
    {
      title: 'Summer Vacation Begins (Grades Pre-Primary to XII)',
      start: new Date(2025, 4, 17), // January 1, 2025 (all-day)
      end: new Date(2025, 5, 25),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'WinterBreak',
    },
    {
      title: 'Maharana Pratap Jayanti',
      start: new Date(2025, 4, 29), // January 1, 2025 (all-day)
      end: new Date(2025, 4, 29),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'WinterBreak',
    },
    {
      title: 'World No Tobacco Day',
      start: new Date(2025, 4, 31), // January 1, 2025 (all-day)
      end: new Date(2025, 4, 31),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'World Environment Day',
      start: new Date(2025, 5, 5), // January 1, 2025 (all-day)
      end: new Date(2025, 5, 5),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'ID-UI-Zuha',
      start: new Date(2025, 5, 7), // January 1, 2025 (all-day)
      end: new Date(2025, 5, 7),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'World Oceans Day',
      start: new Date(2025, 5, 8), // January 1, 2025 (all-day)
      end: new Date(2025, 5, 8),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Father's Day",
      start: new Date(2025, 5, 15), // January 1, 2025 (all-day)
      end: new Date(2025, 5, 15),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'National Reading Day',
      start: new Date(2025, 5, 19), // January 1, 2025 (all-day)
      end: new Date(2025, 5, 19),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'International Yoga Day Celebration',
      start: new Date(2025, 5, 21), // January 1, 2025 (all-day)
      end: new Date(2025, 5, 21),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Horizontal Collaborative meeting for Educators',
      start: new Date(2025, 5, 23), // January 1, 2025 (all-day)
      end: new Date(2025, 5, 23),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Review of School Policies by Educators',
      start: new Date(2025, 5, 24), // January 1, 2025 (all-day)
      end: new Date(2025, 5, 24),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'School Reopens',
      start: new Date(2025, 5, 25), // January 1, 2025 (all-day)
      end: new Date(2025, 5, 25),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: 'Inter House Designing Competition (Grades VI to VIII)',
      start: new Date(2025, 6, 2), // January 1, 2025 (all-day)
      end: new Date(2025, 6, 2),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'Muharram',
      start: new Date(2025, 6, 6), // January 1, 2025 (all-day)
      end: new Date(2025, 6, 6),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Pre-Primary Orange Colour Day',
      start: new Date(2025, 6, 8), // January 1, 2025 (all-day)
      end: new Date(2025, 6, 8),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Inter Hous Best out of Waste competition (Grades I to V)',
      start: new Date(2025, 6, 9), // January 1, 2025 (all-day)
      end: new Date(2025, 6, 9),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'Guru Purnima',
      start: new Date(2025, 6, 10), // January 1, 2025 (all-day)
      end: new Date(2025, 6, 10),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Sanskar Model United Nations',
      start: new Date(2025, 6, 11), // January 1, 2025 (all-day)
      end: new Date(2025, 6, 11),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'National Paper Bag Day',
      start: new Date(2025, 6, 12), // January 1, 2025 (all-day)
      end: new Date(2025, 6, 12),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Sanskar Modal United Nations',
      start: new Date(2025, 6, 12), // January 1, 2025 (all-day)
      end: new Date(2025, 6, 12),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Youth Skill Day Skill Fest (Grades III to XII)',
      start: new Date(2025, 6, 15), // January 1, 2025 (all-day)
      end: new Date(2025, 6, 15),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Well Being Workshop (Grades I to V)',
      start: new Date(2025, 6, 18), // January 1, 2025 (all-day)
      end: new Date(2025, 6, 18),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: 'Investiture Ceremony',
      start: new Date(2025, 6, 19), // January 1, 2025 (all-day)
      end: new Date(2025, 6, 19),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },

    {
      title: 'Observance of Light Off Hour',
      start: new Date(2025, 6, 19), // January 1, 2025 (all-day)
      end: new Date(2025, 6, 19),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: 'Evacuation Mock Drill',
      start: new Date(2025, 6, 21), // January 1, 2025 (all-day)
      end: new Date(2025, 6, 21),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Deeply Seeded (Grades VI to XII)',
      start: new Date(2025, 6, 23), // January 1, 2025 (all-day)
      end: new Date(2025, 6, 23),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Pre-Primary Meditation Day',
      start: new Date(2025, 6, 25), // January 1, 2025 (all-day)
      end: new Date(2025, 6, 25),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Open House (Grades Pre-Primary to V)',
      start: new Date(2025, 7, 2), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 2),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: 'Pre-Primary Green Colour Day',
      start: new Date(2025, 7, 5), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 5),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Inter House Financial Management Reel Making Competition (Grades VI to VIII)',
      start: new Date(2025, 7, 6), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 6),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'Inter House Ad Mad Competition (Grades IX to XII)',
      start: new Date(2025, 7, 6), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 6),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'Pre Primary Gardening Day',
      start: new Date(2025, 7, 8), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 8),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Financial Literacy Week (Grades I to VIII)',
      start: new Date(2025, 7, 8), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 8),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: 'Raksha Bandhan',
      start: new Date(2025, 7, 9), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 9),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: "The International Day of the World's Indigenous People",
      start: new Date(2025, 7, 9), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 9),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Inter House Patriotic Song Competition (Grades I to VIII)',
      start: new Date(2025, 7, 13), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 13),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'Independence Day Celebration',
      start: new Date(2025, 7, 15), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 15),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'Janmashtami',
      start: new Date(2025, 7, 16), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 16),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: 'World Photography Day',
      start: new Date(2025, 7, 19), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 19),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Inter House Short Film Making Competition (Grades VI to XII)',
      start: new Date(2025, 7, 19), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 19),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: 'Special Assembly: Skit on Awareness about Inclusivity VI to VII',
      start: new Date(2025, 7, 22), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 22),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    
    {
      title: 'Well Being Workshop (Grades I to V)',
      start: new Date(2025, 7, 22), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 22),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: 'Observance of Light off Hour',
      start: new Date(2025, 7, 23), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 23),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: 'Ganesh Chaturthi',
      start: new Date(2025, 7, 27), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 27),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'National Sports Day Indigenous Sports Activity',
      start: new Date(2025, 7, 29), // January 1, 2025 (all-day)
      end: new Date(2025, 7, 29),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Ramdev Jayanti',
      start: new Date(2025, 8, 2), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 2),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: 'Barawafat',
      start: new Date(2025, 8, 5), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 2),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: "Teacher's Day",
      start: new Date(2025, 8, 5), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 2),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: 'International Day of Charity',
      start: new Date(2025, 8, 5), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 2),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Grandparent's Day Celebration (Grades Pre-Primary to II)",
      start: new Date(2025, 8, 6), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 6),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Grandparent's Day",
      start: new Date(2025, 8, 7), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 7),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Inter House Hindi Debata Competition (Grades I to V) ",
      start: new Date(2025, 8, 10), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 10),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
    {
      title: "9/11 Remembrance Day",
      start: new Date(2025, 8, 11), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 11),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Pre-Primary Elocution",
      start: new Date(2025, 8, 12), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 12),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: "First Aid Training",
      start: new Date(2025, 8, 12), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 12),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Art',
    },
    {
      title: "World First Aid Day",
      start: new Date(2025, 8, 13), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 13),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Hindi Diwas",
      start: new Date(2025, 8, 14), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 14),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Pre-Primary Blue Colour Day",
      start: new Date(2025, 8, 16), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 16),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
    {
      title: "Observance of Light off Hour",
      start: new Date(2025, 8, 20), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 20),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
    {
      title: "International Day of Peace",
      start: new Date(2025, 8, 21), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 21),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Navratra Sthapna",
      start: new Date(2025, 8, 22), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 22),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: "Reflective Collaborative meenting for Educators",
      start: new Date(2025, 8, 24), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 24),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Well Being Workshop (Grades I to V)",
      start: new Date(2025, 8, 24), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 24),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
    {
      title: "World Tourism Day Global Virtual Visit",
      start: new Date(2025, 8, 27), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 27),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Navratri Celebration",
      start: new Date(2025, 8, 29), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 29),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Durga Ashtami",
      start: new Date(2025, 8, 30), // January 1, 2025 (all-day)
      end: new Date(2025, 8, 30),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: "Maha Navami",
      start: new Date(2025, 9, 1), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 1),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: "World Vegetarian Day",
      start: new Date(2025, 9, 1), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 1),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Gandhi Jayanti",
      start: new Date(2025, 9, 2), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 2),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: "Dussehra",
      start: new Date(2025, 9, 2), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 2),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Holiday',
    },
    {
      title: "Open House for Result Declaration (Grades I to V)",
      start: new Date(2025, 9, 4), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 4),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
    {
      title: "Pre-Primary White Colour Day",
      start: new Date(2025, 9, 7), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 7),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'PrePrimary',
    },
    {
      title: "Indian Air Force Day",
      start: new Date(2025, 9, 8), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 8),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
    {
      title: "World Mental Health Day",
      start: new Date(2025, 9, 10), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 10),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
    {
      title: "Open House for Result Declaration (Grades I to V)",
      start: new Date(2025, 9, 11), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 11),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "No Bag Day",
      start: new Date(2025, 9, 13), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 13),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Well Being Workshop (Grades I to V)",
      start: new Date(2025, 9, 13), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 13),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'CBP4Edu',
    },
      {
      title: "No Bag Day",
      start: new Date(2025, 9, 14), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 14),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Pre-Primary Card Making",
      start: new Date(2025, 9, 14), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 14),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
         {
      title: "No Bag Day",
      start: new Date(2025, 9, 15), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 15),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Inter House Fire Less Cooking Competition (Grades I to V)",
      start: new Date(2025, 9, 15), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 15),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
     {
      title: "World Food Day",
      start: new Date(2025, 9, 16), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 16),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
       category: 'SpecialDay',
    },
     {
      title: "No Bag Day",
      start: new Date(2025, 9, 16), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 16),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
       category: 'SpecialDay',
    },
     {
      title: "Ramayana Stage Show",
      start: new Date(2025, 9, 16), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 16),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
       category: 'Observance',
    },
     {
      title: "Observance of Light off Hour",
      start: new Date(2025, 9, 18), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 18),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
       category: 'Observance',
    },
     {
      title: "Diwali Break",
      start: new Date(2025, 9, 19), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 24),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'WinterBreak',
    },    
     {
      title: "United Nations Day",
      start: new Date(2025, 9, 24), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 24),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
     {
      title: "Collaborative Meeting for Educators",
      start: new Date(2025, 9, 29), // January 1, 2025 (all-day)
      end: new Date(2025, 9, 29),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
     {
      title: "Sanskar Talks (Grades IX-XII)",
      start: new Date(2025, 10, 1), // January 1, 2025 (all-day)
      end: new Date(2025, 10, 1),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
     {
      title: "Pre-Primay Brown Color Day",
      start: new Date(2025, 10, 4), // January 1, 2025 (all-day)
      end: new Date(2025, 10, 4),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
       category: 'PrePrimary',
    },
     {
      title: "Guru Nanak Jayanti",
      start: new Date(2025, 10, 5), // January 1, 2025 (all-day)
      end: new Date(2025, 10, 5),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
       category: 'Holiday',
    },   
     {
      title: "International Day Against Violence Well Being Session (Anti Bullying)",
      start: new Date(2025, 10, 7), // January 1, 2025 (all-day)
      end: new Date(2025, 10, 7),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    }, 
     {
      title: "Inter House English Elocution Competition (Grades I to V)",
      start: new Date(2025, 10, 12), // January 1, 2025 (all-day)
      end: new Date(2025, 10, 12),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'InterHouse1to5',
    },
     {
      title: "World Kindness Day",
      start: new Date(2025, 10, 13), // January 1, 2025 (all-day)
      end: new Date(2025, 10, 13),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Children's Day",
      start: new Date(2025, 10, 13), // January 1, 2025 (all-day)
      end: new Date(2025, 10, 13),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Children's Day",
      start: new Date(2025, 10, 14), // January 1, 2025 (all-day)
      end: new Date(2025, 10, 14),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'Observance',
    },   
     {
      title: "Talent Show",
      start: new Date(2025, 10, 14), // January 1, 2025 (all-day)
      end: new Date(2025, 10, 14),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Observance of Light off Hour",
      start: new Date(2025, 10, 15), // January 1, 2025 (all-day)
      end: new Date(2025, 10, 15),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'Observance',
    },
     {
      title: "Well Being Workshop (Grades I to V)",
      start: new Date(2025, 10, 21), // January 1, 2025 (all-day)
      end: new Date(2025, 10, 21),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
        category: 'CBP4Edu',
    },   
     {
      title: "Orientation Session (Grade X)",
      start: new Date(2025, 10, 22), // January 1, 2025 (all-day)
      end: new Date(2025, 10, 22),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
        category: 'SpecialDay',
    },
     {
      title: "Pre-Primary Origami Day",
      start: new Date(2025, 10, 25), // January 1, 2025 (all-day)
      end: new Date(2025, 10, 25),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
     {
      title: "Constitution Day Mass Reading of Pramble",
      start: new Date(2025, 10, 26), // January 1, 2025 (all-day)
      end: new Date(2025, 10, 26),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
     {
      title: "Natinal Pollution Control Day",
      start: new Date(2025, 11, 2), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 2),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
     {
      title: "Inter House Spell Buster Competition (Grades I to VII)",
      start: new Date(2025, 11, 3), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 3),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
     {
      title: "Indian Navy Day",
      start: new Date(2025, 11, 4), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 4),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
     {
      title: "Pre-Primary Little Picasso Day",
      start: new Date(2025, 11, 9), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 9),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
     {
      title: "Human Rights Day ",
      start: new Date(2025, 11, 10), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 10),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
     {
      title: "Inter House Advocacy Campaing for Human Rights (Grades IX & XI)",
      start: new Date(2025, 11, 10), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 10),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
     {
      title: "Observance of Ligh Off Hour",
      start: new Date(2025, 11, 13), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 13),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'Observance',
    },
     {
      title: "Mathematics Quiz Round I (Grades IX to XII)",
      start: new Date(2025, 11, 15), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 15),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
     {
      title: "Sudoku Competition (Grades III to VIII)",
      start: new Date(2025, 11, 17), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 17),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'InterHouse1to5',
    },
     {
      title: "Horizontal Callaborative Meeting for Educators",
      start: new Date(2025, 11, 17), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 17),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
     {
      title: "Well Being Workshop (Grades I - V)",
      start: new Date(2025, 11, 18), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 18),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'CBP4Edu',
    },
     {
      title: "Mathematics Quiz Round II (Grades IX to XII)",
      start: new Date(2025, 11, 19), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 19),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
     {
      title: "Annual Prize Distribution",
      start: new Date(2025, 11, 20), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 20),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
     {
      title: "Sanskar Fiesta",
      start: new Date(2025, 11, 21), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 21),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
     {
      title: "National Mathematics Day Veer Bal Diwas",
      start: new Date(2025, 11, 22), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 22),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
     {
      title: "Christmas Celebration",
      start: new Date(2025, 11, 24), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 24),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'SpecialDay',
    },
     {
      title: "Pre-Primary Red Colour Day ",
      start: new Date(2025, 11, 24), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 24),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
      category: 'PrePrimary',
    },
     {
      title: "Inter House Mathematics Quiz Final Round (Grades - IX to XII)",
      start: new Date(2025, 11, 24), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 24),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'InterHouse1to5',
    },
     {
      title: "Christmas",
      start: new Date(2025, 11, 25), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 25),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'Holiday',
    },
     {
      title: "Guru Govind Singh Jayanti",
      start: new Date(2025, 11, 27), // January 1, 2025 (all-day)
      end: new Date(2025, 11, 27),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "winter Break",
      start: new Date(2025, 11, 31), // January 1, 2025 (all-day)
      end: new Date(2026,0, 5),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'WinterBreak',
    },
     {
      title: "Road Safety Drive",
      start: new Date(2026, 0, 10), // January 1, 2025 (all-day)
      end: new Date(2026,0,10),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Makar Sankranti",
      start: new Date(2026, 0, 14), // January 1, 2025 (all-day)
      end: new Date(2026,0,14),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'Holiday',
    },
     {
      title: "Indian Army Day Thanks Giving",
      start: new Date(2026, 0, 15), // January 1, 2025 (all-day)
      end: new Date(2026,0,15),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Pre-Primary Yellow Colour Day",
      start: new Date(2026, 0, 20), // January 1, 2025 (all-day)
      end: new Date(2026,0,20),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'PrePrimary',
    },
     {
      title: "Well-Being Workshop (Grades I to V)",
      start: new Date(2026, 0, 22), // January 1, 2025 (all-day)
      end: new Date(2026,0,22),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'CBP4Edu',
    }, 
     {
      title: "Basant Panchami",
      start: new Date(2026, 0, 22), // January 1, 2025 (all-day)
      end: new Date(2026,0,22),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Republic Day Celebration",
      start: new Date(2026, 0, 26), // January 1, 2025 (all-day)
      end: new Date(2026,0,26),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'Holiday',
    },
     {
      title: "General Heritage Quiz (Grades I to VII)",
      start: new Date(2026, 0, 28), // January 1, 2025 (all-day)
      end: new Date(2026,0,26),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Martyr's Day",
      start: new Date(2026, 0, 30), // January 1, 2025 (all-day)
      end: new Date(2026,0,30),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Collaborative meeting for Educators",
      start: new Date(2026, 1, 3), // January 1, 2025 (all-day)
      end: new Date(2026,1,3),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Graduation Ceremony",
      start: new Date(2026, 1, 7), // January 1, 2025 (all-day)
      end: new Date(2026,1,7),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'Observance',
    },
     {
      title: "International Safer Internet Day Cyber Security Session",
      start: new Date(2026, 1, 10), // January 1, 2025 (all-day)
      end: new Date(2026,1,10),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "International Day of Women & Girls in Science",
      start: new Date(2026, 1, 11), // January 1, 2025 (all-day)
      end: new Date(2026,1,11),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Science Fair (Grades I to V)",
      start: new Date(2026, 1, 14), // January 1, 2025 (all-day)
      end: new Date(2026,1,14),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Maha Shivratri",
      start: new Date(2026, 1, 15), // January 1, 2025 (all-day)
      end: new Date(2026,1,15),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'Holiday',
    },
     {
      title: "Pre-Primary Purple Colour Day",
      start: new Date(2026, 1, 17), // January 1, 2025 (all-day)
      end: new Date(2026,1,17),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'PrePrimary',
    },
     {
      title: "Pre-Primary Picnic Day",
      start: new Date(2026, 1, 20), // January 1, 2025 (all-day)
      end: new Date(2026,1,20),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'PrePrimary',
    },
     {
      title: "Observance of Light off Hour",
      start: new Date(2026, 1, 21), // January 1, 2025 (all-day)
      end: new Date(2026,1,21),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'Observance',
    },
     {
      title: "Well Being Workshop (Grades I - V)",
      start: new Date(2026, 1, 27), // January 1, 2025 (all-day)
      end: new Date(2026,1,27),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'CBP4Edu',
    },
     {
      title: "National Science Day",
      start: new Date(2026, 1, 28), // January 1, 2025 (all-day)
      end: new Date(2026,1,28),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Worl Wildlife Day",
      start: new Date(2026, 2, 3), // January 1, 2025 (all-day)
      end: new Date(2026,2,3),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Holi",
      start: new Date(2026, 2, 4), // January 1, 2025 (all-day)
      end: new Date(2026,2,4),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'Holiday',
    },
     {
      title: "International Women's Day",
      start: new Date(2026, 2, 8), // January 1, 2025 (all-day)
      end: new Date(2026,2,8),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "World Consumer Rights Day",
      start: new Date(2026, 2, 15), // January 1, 2025 (all-day)
      end: new Date(2026,2,15),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "International Day of Happiness",
      start: new Date(2026, 2, 20), // January 1, 2025 (all-day)
      end: new Date(2026,2,20),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Eid-ul Fitr",
      start: new Date(2026, 2, 21), // January 1, 2025 (all-day)
      end: new Date(2026,2,21),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'Holiday',
    },
     {
      title: "World Poetry Day",
      start: new Date(2026, 2, 21), // January 1, 2025 (all-day)
      end: new Date(2026,2,21),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "World Water Day",
      start: new Date(2026, 2, 22), // January 1, 2025 (all-day)
      end: new Date(2026,2,22),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'SpecialDay',
    },
     {
      title: "Open House for Result Declaration (Grades Pre-Primary to II)",
      start: new Date(2026, 2, 25), // January 1, 2025 (all-day)
      end: new Date(2026,2,25),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'Observance',
    },
     {
      title: "Ram Navami",
      start: new Date(2026, 2, 26), // January 1, 2025 (all-day)
      end: new Date(2026,2,26),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'Holiday',
    },
     {
      title: "Open House for Result Declaration (Grades III to V) ",
      start: new Date(2026, 2, 27), // January 1, 2025 (all-day)
      end: new Date(2026,2,27),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'Observance',
    },
     {
      title: "Open House for Result Declaration (Grades VI to IX & XI) ",
      start: new Date(2026, 2, 28), // January 1, 2025 (all-day)
      end: new Date(2026,2,28),   // January 8, 2025 (all-day)
      allDay: true, // Mark it as an all-day event
     category: 'Observance',
    },
     {
  title: "Collaborative Meetings and Professional Development Sessions",
  start: new Date(2026, 3, 2),
  end: new Date(2026, 3, 2),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "Good Friday",
  start: new Date(2026, 3, 3),
  end: new Date(2026, 3, 3),
  allDay: true,
  category: 'SpecialDay' 
},
     {
  title: "Collaborative Meetings and Professional Development Sessions",
  start: new Date(2026, 3, 3),
  end: new Date(2026, 3, 3),
  allDay: true,
  category: 'PrePrimary' 
},
     {
  title: "Collaborative Meetings and Professional Development Sessions",
  start: new Date(2026, 3, 4),
  end: new Date(2026, 3, 4),
  allDay: true,
  category: 'PrePrimary' 
},

{
  title: "New Session Begins",
  start: new Date(2026, 3, 6),
  end: new Date(2026, 3, 6),
  allDay: true,
  category: 'Observance' 
},
{
  title: "World Health Day",
  start: new Date(2026, 3, 7),
  end: new Date(2026, 3, 7),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Global University Fair",
  start: new Date(2026, 3, 10),
  end: new Date(2026, 3, 10),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Jyotiba Phule Jayanti",
  start: new Date(2026, 3, 11),
  end: new Date(2026, 3, 11),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Open House (Grades Pre-Primary to V) Parent Orientation",
  start: new Date(2026, 3, 11),
  end: new Date(2026, 3, 11),
  allDay: true,
  category: 'Observance' 
},
{
  title: "U.S.A. University Fair",
  start: new Date(2026, 3, 13),
  end: new Date(2026, 3, 13),
  allDay: true,
  category: 'SpecialDay' 

},
{
  title: "Dr. B.R. Ambedkar Jayanti",
  start: new Date(2026, 3, 14),
  end: new Date(2026, 3, 14),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Kanni Tharyamal Sports Tournament",
  start: new Date(2026, 3, 15),
  end: new Date(2026, 3, 15),
  allDay: true,
  category: 'Observance' 
},
{
  title: "Inter-House Art Competition (Classes I to V)",
  start: new Date(2026, 3, 15),
  end: new Date(2026, 3, 15),
  allDay: true,
  category: 'PrePrimary' 
  // category: 'CBP4Edu' 
},
{
  title: "World Art Day",
  start: new Date(2026, 3, 16),
  end: new Date(2026, 3, 16),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Pre-Primary Puppet Show",
  start: new Date(2026, 3, 17),
  end: new Date(2026, 3, 17),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "Observance of Light off Hour",
  start: new Date(2026, 3, 18),
  end: new Date(2026, 3, 18),
  allDay: true,
  category: 'Observance' 
},
{
  title: "World Heritage Day & Inter-House Competitions (Classes VI-XII)",
  start: new Date(2026, 3, 18),
  end: new Date(2026, 3, 18),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "ATL Community Day",
  start: new Date(2026, 3, 20),
  end: new Date(2026, 3, 20),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "World Creativity & Innovation Day",
  start: new Date(2026, 3, 21),
  end: new Date(2026, 3, 21),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Time Capsule Day (Grade IV and V)",
  start: new Date(2026, 3, 21),
  end: new Date(2026, 3, 21),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "International Mother Earth Day & Green Pledge Drive",
  start: new Date(2026, 3, 22),
  end: new Date(2026, 3, 22),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Inter House Handwriting/Creative Writing/Heritage Quiz",
  start: new Date(2026, 3, 22),
  end: new Date(2026, 3, 22),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "English Language Day",
  start: new Date(2026, 3, 23),
  end: new Date(2026, 3, 23),
  allDay: true,
  category: 'SpecialDay' 
},
  {
    title: "Mosaic- Inter School Art Fest",
    start: new Date(2026, 3, 25),
    end: new Date(2026, 3, 25),
    allDay: true,
    category: 'Observance' 
  },  

  {
    title: "International Labour Day",
    start: new Date(2026, 4, 1),
    end: new Date(2026, 4, 1),
    allDay: true,
    category: 'SpecialDay' 
  },
  {
    title: "Donation Drive (Classes VI-XII)",
    start: new Date(2026, 4, 1),
    end: new Date(2026, 4, 1),
    allDay: true,
    category: 'CBP4Edu' 
  },

  {
    title: "Observance of Light off Hour",
    start: new Date(2026, 4, 2),
    end: new Date(2026, 4, 2),
    allDay: true,
    category: 'Observance' 
  },
  {
    title: "Pre-Primary Pink Colour Day",
    start: new Date(2026, 4, 5),
    end: new Date(2026, 4, 5),
    allDay: true,
    category: 'PrePrimary' 
  },
  {
    title: "Inter House Recitation Competition (Grade I to V)",
    start: new Date(2026, 4, 6),
    end: new Date(2026, 4, 6),
    allDay: true,
    category: 'CBP4Edu' 
  },
  {
    title: "Inter House Ad Mad Competition (Classes IX-XII)",
    start: new Date(2026, 4, 6),
    end: new Date(2026, 4, 6),
    allDay: true,
    category: 'CBP4Edu' 
  },
  {
    title: "Open House (Classes VI to VIII)",
    start: new Date(2026, 4, 9),
    end: new Date(2026, 4, 9),
    allDay: true,
    category: 'Observance' 
  },
  {
    title: "Mother's Day",
    start: new Date(2026, 4, 10),
    end: new Date(2026, 4, 10),
    allDay: true,
    category: 'SpecialDay' 
  },
  {
    title: "World Technology Day",
    start: new Date(2026, 4, 11),
    end: new Date(2026, 4, 11),
    allDay: true,
    category: 'SpecialDay' 
  },
  {
    title: "Intra Class Traditional Food Fest (Classes VI-VIII)",
    start: new Date(2026, 4, 13),
    end: new Date(2026, 4, 13),
    allDay: true,
    category: 'InterHouse1to5' 
  },
  {
    title: "Glow and Grow Summer Party (Grades Pre-Primary to III)",
    start: new Date(2026, 4, 15),
    end: new Date(2026, 4, 15),
    allDay: true,
    category: 'Art' 
  },
  {
    title: "Summer Vacation Begins (Grades Pre-Primary to VIII)",
    start: new Date(2026, 4, 16),
    end: new Date(2026, 5, 24),
    allDay: true,
    category: 'WinterBreak' 
  },
  {
    title: "Id-Ul-Zuha",
    start: new Date(2026, 4, 27),
    end: new Date(2026, 4, 27),
    allDay: true,
    category: 'Holiday' 
  },
  {
    title: "World No Tobacco Day",
    start: new Date(2026, 4, 31),
    end: new Date(2026, 4, 31),
    allDay: true,
    category: 'SpecialDay' 
  },

{
  title: "World Environment Day",
  start: new Date(2026, 5, 5),
  end: new Date(2026, 5, 5),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "World Oceans Day",
  start: new Date(2026, 5, 8),
  end: new Date(2026, 5, 8),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Maharana Pratap Jayanti",
  start: new Date(2026, 5, 17),
  end: new Date(2026, 5, 17),
  allDay: true,
  category: 'Holiday' 
},
{
  title: "National Reading Day",
  start: new Date(2026, 5, 19),
  end: new Date(2026, 5, 19),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "International Yoga Day Celebration",
  start: new Date(2026, 5, 21),
  end: new Date(2026, 5, 21),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Father's Day",
  start: new Date(2026, 5, 21),
  end: new Date(2026, 5, 21),
  allDay: true,
  category: 'Holiday' 
},
// {
//   title: "Father's Day",
//   start: new Date(2026, 5, 21),
//   end: new Date(2026, 5, 21),
//   allDay: true,
//   category: 'Holiday ' 
// },
{
  title: "Review of School Policies by Educators and Professional Development Sessions",
  start: new Date(2026, 5, 22),
  end: new Date(2026, 5, 22),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Review of School Policies by Educators and Professional Development Sessions",
  start: new Date(2026, 5, 23),
  end: new Date(2026, 5, 23),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "School Reopens",
  start: new Date(2026, 5, 24),
  end: new Date(2026, 5, 24),
  allDay: true,
  category: 'Observance' 
},
{
  title: "Muharram",
  start: new Date(2026, 5, 26),
  end: new Date(2026, 5, 26),
  allDay: true,
  category: 'Holiday' 
},
{
  title: "Pre-Primary Clay Moulding Day",
  start: new Date(2026, 5, 30),
  end: new Date(2026, 5, 30),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "Inter House Designing Competition (Grades VI to VIII)",
  start: new Date(2026, 6, 1),
  end: new Date(2026, 6, 1),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "Pre-Primary Orange Colour Day",
  start: new Date(2026, 6, 7),
  end: new Date(2026, 6, 7),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "Inter House Origami Competition (Grades I to V)",
  start: new Date(2026, 6, 8),
  end: new Date(2026, 6, 8),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "Inter House Math Relay Quiz (Classes VI-VIII)",
  start: new Date(2026, 6, 8),
  end: new Date(2026, 6, 8),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "Inter House Logic League Quiz (Classes IX-XII)",
  start: new Date(2026, 6, 8),
  end: new Date(2026, 6, 8),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "Sanskar Model United Nations",
  start: new Date(2026, 6, 11),
  end: new Date(2026, 6, 12),
  allDay: true,
  category: 'Observance' 
},
{
  title: "National Paper Bag Day",
  start: new Date(2026, 6, 12),
  end: new Date(2026, 6, 12),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Sanskar Model United Nations",
  start: new Date(2026, 6, 12),
  end: new Date(2026, 6, 12),
  allDay: true,
  category: 'Observance' 
},
{
  title: "Youth Skill Day",
  start: new Date(2026, 6, 15),
  end: new Date(2026, 6, 15),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Well Being Workshop (Grades I to V)",
  start: new Date(2026, 6, 17),
  end: new Date(2026, 6, 17),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "Observance of Light Off Hour",
  start: new Date(2026, 6, 18),
  end: new Date(2026, 6, 18),
  allDay: true,
  category: 'Observance' 
},
{
  title: "Investiture Ceremony",
  start: new Date(2026, 6, 18),
  end: new Date(2026, 6, 18),
  allDay: true,
  category: 'Observance' 
},
{
  title: "Evacuation Mock Drill",
  start: new Date(2026, 6, 21),
  end: new Date(2026, 6, 21),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Inter House Maths Quiz (Grades I to V)",
  start: new Date(2026, 6, 22),
  end: new Date(2026, 6, 22),
  allDay: true,
  category: 'InterHouse1to5' 
},
{
  title: "Inter House Innovation Pitch- Sanskar Shark Tank (Grades IX to XII)",
  start: new Date(2026, 6, 22),
  end: new Date(2026, 6, 22),
  allDay: true,
  category: 'InterHouse1to5' 
},
{
  title: "Deeply Seeded (Grades VI to XII)",
  start: new Date(2026, 6, 23),
  end: new Date(2026, 6, 23),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Pre-Primary Meditation Day",
  start: new Date(2026, 6, 24),
  end: new Date(2026, 6, 24),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "Paper Usage Audit (Classes VI-VIII)",
  start: new Date(2026, 6, 25),
  end: new Date(2026, 6, 25),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "Paper Conservation Campaign (Classes IX-XII)",
  start: new Date(2026, 6, 25),
  end: new Date(2026, 6, 25),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "Guru Purnima",
  start: new Date(2026, 6, 29),
  end: new Date(2026, 6, 29),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Open House (Grades Pre-Primary to V)",
  start: new Date(2026, 7, 1),
  end: new Date(2026, 7, 1),
  allDay: true,
  category: 'Observance' 
},
{
  title: "Pre-Primary Green Colour Day",
  start: new Date(2026, 7, 4),
  end: new Date(2026, 7, 4),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "Pre Primary Gardening Day",
  start: new Date(2026, 7, 7),
  end: new Date(2026, 7, 7),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "Observance of Light off Hour",
  start: new Date(2026, 7, 8),
  end: new Date(2026, 7, 8),
  allDay: true,
  category: 'Observance' 
},
{
  title: "The International Day of the World's Indigenous People",
  start: new Date(2026, 7, 9),
  end: new Date(2026, 7, 9),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Inter House Tableau Presentation on 'My Country India' (Grades I to V)",
  start: new Date(2026, 7, 12),
  end: new Date(2026, 7, 12),
  allDay: true,
  category: 'CBP4Edu ' 
},
{
  title: "Inter House Free-Style Dance Competition (Grades VI to VIII)",
  start: new Date(2026, 7, 12),
  end: new Date(2026, 7, 12),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "Inter House Folk Group Dance Competition (Grades IX to XII)",
  start: new Date(2026, 7, 12),
  end: new Date(2026, 7, 12),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "Independence Day Celebration",
  start: new Date(2026, 7, 15),
  end: new Date(2026, 7, 15),
  allDay: true,
  category: 'Holiday' 
},
{
  title: "World Photography Day",
  start: new Date(2026, 7, 19),
  end: new Date(2026, 7, 19),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Inter House Short Film Making Competition (Grades VI to XII)",
  start: new Date(2026, 7, 19),
  end: new Date(2026, 7, 19),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "Well Being Workshop (Grades I to V)",
  start: new Date(2026, 7, 21),
  end: new Date(2026, 7, 21),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "Barawafat",
  start: new Date(2026, 7, 26),
  end: new Date(2026, 7, 26),
  allDay: true,
  category: 'Holiday' 
},
{
  title: "Raksha Bandhan",
  start: new Date(2026, 7, 28),
  end: new Date(2026, 7, 28),
  allDay: true,
  category: 'Holiday' 
},
{
  title: "Indigenous Sports (Classes VI-XII) - National Sports Day",
  start: new Date(2026, 7, 29),
  end: new Date(2026, 7, 29),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: " National Sports Day",
  start: new Date(2026, 7, 29),
  end: new Date(2026, 7, 29),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Janmashtami",
  start: new Date(2026, 8, 4),
  end: new Date(2026, 8, 4),
  allDay: true,
  category: 'Holiday' 
},
{
  title: "Teachers' Day",
  start: new Date(2026, 8, 5),
  end: new Date(2026, 8, 5),
  allDay: true,
  category: 'Observance' 
},
{
  title: "Inter House Hindi Debate Competition (Grades I to V)",
  start: new Date(2026, 8, 9),
  end: new Date(2026, 8, 9),
  allDay: true,
  category: 'InterHouse1to5' 
},
{
  title: "9/11 Remembrance Day",
  start: new Date(2026, 8, 11),
  end: new Date(2026, 8, 11),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Grandparents' Day",
  start: new Date(2026, 8, 13),
  end: new Date(2026, 8, 13),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Hindi Diwas",
  start: new Date(2026, 8, 14),
  end: new Date(2026, 8, 14),
  allDay: true,
  category: '' 
},
{
  title: "Ganesh Chaturthi",
  start: new Date(2026, 8, 14),
  end: new Date(2026, 8, 14),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Pre-Primary Blue Colour Day",
  start: new Date(2026, 8, 15),
  end: new Date(2026, 8, 15),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "Observance of Light off Hour",
  start: new Date(2026, 8, 19),
  end: new Date(2026, 8, 19),
  allDay: true,
  category: 'Observance' 
},
{
  title: "International Day of Peace Assembly on Global Harmony",
  start: new Date(2026, 8, 21),
  end: new Date(2026, 8, 21),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Ramdev Jayanti",
  start: new Date(2026, 8, 21),
  end: new Date(2026, 8, 21),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "World Tourism Day",
  start: new Date(2026, 8, 27),
  end: new Date(2026, 8, 27),
  allDay: true,
  category: 'SpecialDay' 
},

{
  title: "Gandhi Jayanti",
  start: new Date(2026, 9, 2),
  end: new Date(2026, 9, 2),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Art Exhibition (Grades I to XII)",
  start: new Date(2026, 9, 2),
  end: new Date(2026, 9, 3),
  allDay: true,
  category: 'Observance' 
},
{
  title: "Art Exhibition (Grades I to XII)",
  start: new Date(2026, 9, 3),
  end: new Date(2026, 9, 3),
  allDay: true,
  category: 'Observance' 
},
{
  title: "Open House (Grades Pre-Primary to XII)",
  start: new Date(2026, 9, 3),
  end: new Date(2026, 9, 3),
  allDay: true,
  category: 'Observance' 
},
{
  title: "Pre-Primary White Colour Day",
  start: new Date(2026, 9, 6),
  end: new Date(2026, 9, 6),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "No Bag Day",
  start: new Date(2026, 9, 7),
  end: new Date(2026, 9, 8),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Inter House Shloka Competition (Grades I to V)",
  start: new Date(2026, 9, 7),
  end: new Date(2026, 9, 7),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "Indian Air Force Day",
  start: new Date(2026, 9, 8),
  end: new Date(2026, 9, 8),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "World Mental Health Day",
  start: new Date(2026, 9, 10),
  end: new Date(2026, 9, 10),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Navratra Sthapna",
  start: new Date(2026, 9, 11),
  end: new Date(2026, 9, 11),
  allDay: true,
  category: 'Holiday' 
},
{
  title: "Inter House Fire Less Cooking Competition (Grades I to V)",
  start: new Date(2026, 9, 14),
  end: new Date(2026, 9, 14),
  allDay: true,
  category: 'InterHouse1to5' 
},
{
  title: "Inter House Design a Robot Competition (Classes VI-VIII)",
  start: new Date(2026, 9, 14),
  end: new Date(2026, 9, 14),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "World Food Day Grain Donation Drive",
  start: new Date(2026, 9, 16),
  end: new Date(2026, 9, 16),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Label Reading Activity",
  start: new Date(2026, 9, 16),
  end: new Date(2026, 9, 16),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "Dussehra Break",
  start: new Date(2026, 9, 17),
  end: new Date(2026, 9, 20),
  allDay: true,
  category: 'WinterBreak' 
},
{
  title: "Observance of Light off Hour",
  start: new Date(2026, 9, 24),
  end: new Date(2026, 9, 24),
  allDay: true,
  category: 'Observance' 
},
{
  title: "United Nations Day",
  start: new Date(2026, 9, 24),
  end: new Date(2026, 9, 24),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Primary and Pre-Primary Ethnic Day",
  start: new Date(2026, 9, 27),
  end: new Date(2026, 9, 27),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "Sanskar Talks (Grades IX & XI)",
  start: new Date(2026, 10, 2),
  end: new Date(2026, 10, 2),
  allDay: true,
  category: 'Observance' 
},
{
  title: "Pre-Primary Brown Color Day",
  start: new Date(2026, 10, 3),
  end: new Date(2026, 10, 3),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "Diwali Break",
  start: new Date(2026, 10, 6),
  end: new Date(2026, 10, 11),
  allDay: true,
  category: 'WinterBreak' 
},
{
  title: "World Kindness Day",
  start: new Date(2026, 10, 13),
  end: new Date(2026, 10, 13),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Well Being Workshop (Grades I to V)",
  start: new Date(2026, 10, 13),
  end: new Date(2026, 10, 13),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "Children's Day",
  start: new Date(2026, 10, 14),
  end: new Date(2026, 10, 14),
  allDay: true,
  category: 'Observance' 
},
{
  title: "Pre-Primary Little Scientist Day",
  start: new Date(2026, 10, 17),
  end: new Date(2026, 10, 17),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "Inter House English Elocution Competition (Grades I to V)",
  start: new Date(2026, 10, 18),
  end: new Date(2026, 10, 18),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "Orientation Session (Grade X)",
  start: new Date(2026, 10, 21),
  end: new Date(2026, 10, 21),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Observance of Light off Hour",
  start: new Date(2026, 10, 21),
  end: new Date(2026, 10, 21),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "Guru Nanak Jayanti",
  start: new Date(2026, 10, 24),
  end: new Date(2026, 10, 24),
  allDay: true,
  category: 'Holiday' 
},
{
  title: "Constitution Day Mass Reading of Preamble",
  start: new Date(2026, 10, 26),
  end: new Date(2026, 10, 26),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "National Pollution Control Day",
  start: new Date(2026, 11, 2),
  end: new Date(2026, 11, 2),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Indian Navy Day",
  start: new Date(2026, 11, 4),
  end: new Date(2026, 11, 4),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Sports Day",
  start: new Date(2026, 11, 6),
  end: new Date(2026, 11, 6),
  allDay: true,
  category: 'Observance' 
},
{
  title: "Inter House Spell Buster Competition (Grades I to VIII)",
  start: new Date(2026, 11, 9),
  end: new Date(2026, 11, 9),
  allDay: true,
  category: 'Art' 
},
{
  title: "Human Rights Day",
  start: new Date(2026, 11, 10),
  end: new Date(2026, 11, 10),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Inter-House Art Eco-Poster Making (Classes VI-VIII)",
  start: new Date(2026, 11, 16),
  end: new Date(2026, 11, 16),
  allDay: true,
  category: 'Art' 
},
{
  title: "Annual Prize Distribution",
  start: new Date(2026, 11, 19),
  end: new Date(2026, 11, 19),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "National Mathematics Day",
  start: new Date(2026, 11, 22),
  end: new Date(2026, 11, 22),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Veer Bal Diwas",
  start: new Date(2026, 11, 22),
  end: new Date(2026, 11, 22),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Math Magic Day (Grades I to V)",
  start: new Date(2026, 11, 23),
  end: new Date(2026, 11, 23),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "Pre-Primary Red Colour Day",
  start: new Date(2026, 11, 24),
  end: new Date(2026, 11, 24),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "Christmas",
  start: new Date(2026, 11, 25),
  end: new Date(2026, 11, 25),
  allDay: true,
  category: 'Holiday' 
},
{
  title: "Sanskar Fiesta",
  start: new Date(2026, 11, 25),
  end: new Date(2026, 11, 25),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Makar Sankranti",
  start: new Date(2027, 0, 15),
  end: new Date(2027, 0, 15),
  allDay: true,
  category: 'Holiday' 
},
{
  title: "Guru Gobind Singh Jayanti",
  start: new Date(2027, 0, 15),
  end: new Date(2027, 0, 15),
  allDay: true,
  category: 'Holiday' 
},
{
  title: "Indian Army Day",
  start: new Date(2027, 0, 15),
  end: new Date(2027, 0, 15),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Pre-Primary Purple Colour Day",
  start: new Date(2027, 0, 19),
  end: new Date(2027, 0, 19),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "National Road Safety Day",
  start: new Date(2027, 0, 19),
  end: new Date(2027, 0, 19),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Republic Day",
  start: new Date(2027, 0, 26),
  end: new Date(2027, 0, 26),
  allDay: true,
  category: 'Holiday' 
},
{
  title: "Martyr's Day",
  start: new Date(2027, 0, 30),
  end: new Date(2027, 0, 30),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Graduation Ceremony",
  start: new Date(2027, 1, 6),
  end: new Date(2027, 1, 6),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Pre-Primary Yellow Colour Day",
  start: new Date(2027, 1, 9),
  end: new Date(2027, 1, 9),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "International Safer Internet Day",
  start: new Date(2027, 1, 10),
  end: new Date(2027, 1, 10),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Cyber Security Session",
  start: new Date(2027, 1, 10),
  end: new Date(2027, 1, 10),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "International Day of Women & Girls in Science",
  start: new Date(2027, 1, 11),
  end: new Date(2027, 1, 11),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Basant Panchami",
  start: new Date(2027, 1, 11),
  end: new Date(2027, 1, 11),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "Well Being Workshop (Grades I to V)",
  start: new Date(2027, 1, 19),
  end: new Date(2027, 1, 19),
  allDay: true,
  category: 'CBP4Edu' 
},
{
  title: "International Mother Language Day",
  start: new Date(2027, 1, 21),
  end: new Date(2027, 1, 21),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "National Science Day",
  start: new Date(2027, 1, 28),
  end: new Date(2027, 1, 28),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "World Wildlife Day",
  start: new Date(2027, 2, 3),
  end: new Date(2027, 2, 3),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Maha Shivratri",
  start: new Date(2027, 2, 6),
  end: new Date(2027, 2, 6),
  allDay: true,
  category: 'Holiday' 
},
{
  title: "International Women's Day",
  start: new Date(2027, 2, 8),
  end: new Date(2027, 2, 8),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Pre - Primary Dress Like Your Dream",
  start: new Date(2027, 2, 9),
  end: new Date(2027, 2, 9),
  allDay: true,
  category: 'PrePrimary' 
},
{
  title: "Inter House Quiz on India Competition (Grades IV to V)",
  start: new Date(2027, 2, 9),
  end: new Date(2027, 2, 9),
  allDay: true,
  category: 'Art' 
},
{
  title: "Eid-Ul-Fitr",
  start: new Date(2027, 2, 10),
  end: new Date(2027, 2, 10),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "World Consumer Rights Day",
  start: new Date(2027, 2, 15),
  end: new Date(2027, 2, 15),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "International Day of Happiness",
  start: new Date(2027, 2, 20),
  end: new Date(2027, 2, 20),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "World Poetry Day",
  start: new Date(2027, 2, 21),
  end: new Date(2027, 2, 21),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Holi",
  start: new Date(2027, 2, 22),
  end: new Date(2027, 2, 22),
  allDay: true,
  category: 'Holiday' 
},
{
  title: "World Water Day",
  start: new Date(2027, 2, 22),
  end: new Date(2027, 2, 22),
  allDay: true,
  category: 'SpecialDay' 
},
{
  title: "Good Friday",
  start: new Date(2027, 2, 26),
  end: new Date(2027, 2, 26),
  allDay: true,
  category: 'SpecialDay' 
}

    
  
    
   
   
  ];

  // Function to customize day styles
  const dayPropGetter = (date) => {
    if (date.getDay() === 0) { // 0 represents Sunday
      return { className: 'sunday-cell' }; // Apply custom class
    }
    return {};
  };

  const eventPropGetter = (event) => {
    const categoryStyles = {
      Holiday: { backgroundColor: 'transparent', color: '#ff0000' },
      SpecialDay: { backgroundColor: 'transparent', color: '#000000' },
      PrePrimary: { backgroundColor: 'transparent', color: '#3174ad' },
      CBP4Edu: { backgroundColor: 'transparent', color: '#16106e' },
      Observance: { backgroundColor: 'transparent', color: '#16bd2b' },
      InterHouse1to5: { backgroundColor: 'transparent', color: '#ff01bd' },
      WinterBreak: { backgroundColor: '#ff0000', color: '#ffffff' },
      collmet: { backgroundColor: '#000000', color: '#ffffff' },
      Art: { backgroundColor: 'transparent', color: '#dd6b26' },
    };
  
    const styles = categoryStyles[event.category] || { backgroundColor: '#6c757d', color: '#ffffff' };
    return {
      style: styles,
    };
  };





  // style={{ margin: '100px' }}

  return (
    <div className='calenderbox'  style={{ height: '500px' }}>
       <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        // style={{ margin: '100px' }}
        dayPropGetter={dayPropGetter}
        eventPropGetter={eventPropGetter}
        views={['month', 'week', 'day', 'agenda']}
        defaultView="month"
        popup
        selectable
        onSelectEvent={(event) => alert(`Event: ${event.title}`)}
        onSelectSlot={(slotInfo) =>
          alert(
            `Selected slot: \nStart: ${slotInfo.start}\nEnd: ${slotInfo.end}`
          )
        }
      />
    </div>
  );
}

export default Mycalendar;

